import React from 'react';
import { Star, Quote } from 'lucide-react';

const TestimonialSection = () => {
  const testimonials = [
    {
      quote: "I had no money, no credit, nothing. They worked with me on a payment plan for just $50 down and got my husband out the same day. They treat you like family, not just another case number.",
      name: "Jennifer L.",
      location: "Modesto, CA",
      plan: "Used Budget Plan - $50 Down",
      rating: 5
    },
    {
      quote: "The 0% down option saved our family when we couldn't afford anything upfront. My son was home in 3 hours and we could manage the monthly payments easily.",
      name: "Maria S.",
      location: "Sacramento, CA", 
      plan: "Used 0% Down Plan (OAC)",
      rating: 5
    },
    {
      quote: "We needed him out fast for work. The Express plan was perfect - higher down payment but very low monthly payments. Worth every penny for the peace of mind.",
      name: "David R.",
      location: "Stockton, CA",
      plan: "Used Express Plan - 25% Down",
      rating: 5
    }
  ];

  return (
    <section className="py-16 bg-blue-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-black text-gray-900 mb-6">
            Real Families, Real Payment Plans
          </h2>
          <p className="text-xl text-gray-600">
            See how our flexible payment options helped these Sacramento Valley families
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {testimonials?.map((testimonial, index) => (
            <div key={index} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200">
              {/* Quote Icon */}
              <div className="flex justify-center mb-6">
                <Quote className="w-12 h-12 text-blue-600" />
              </div>

              {/* Star Rating */}
              <div className="flex justify-center mb-4">
                {[...Array(testimonial?.rating)]?.map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-yellow-500 fill-current" />
                ))}
              </div>

              {/* Testimonial Quote */}
              <blockquote className="text-gray-700 text-lg leading-relaxed mb-6 italic text-center">
                "{testimonial?.quote}"
              </blockquote>

              {/* Customer Info */}
              <div className="text-center border-t border-gray-200 pt-6">
                <div className="font-bold text-gray-900 text-lg">{testimonial?.name}</div>
                <div className="text-gray-600 mb-3">{testimonial?.location}</div>
                <div className="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-semibold">
                  {testimonial?.plan}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-12 text-center">
          <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ready to Find Your Perfect Payment Plan?
            </h3>
            <p className="text-gray-600 mb-6">
              Our licensed agents will work with you to find a payment option that fits your budget and gets your loved one home tonight.
            </p>
            
            <a 
              href="tel:9168330052"
              className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-bold text-lg transition-all transform hover:scale-105 shadow-lg"
            >
              <span className="mr-3">📞</span>
              Call (916) 833-0052 Now
            </a>
            
            <p className="text-sm text-gray-500 mt-3">
              Available 24/7 • Licensed & Bonded • Serving Sacramento Valley
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;